/**
 * resourceAzureAppService模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceAzureAppService = {
  //分页
  pageWeb(params) {
    return $http.post(`${global.API_URL}/sme/resourceAzureAppService/page`,params);
  },
  //查询账户应用程序服务
  queryAppService(params) {
    return $http.post(`${global.API_URL}/sme/resourceAzureAppService/queryAppService`,params);
  },
  //根据ID查询应用程序服务详情
  queryAppServiceById(params) {
    return $http.post(`${global.API_URL}/sme/resourceAzureAppService/queryAppServiceById`,params);
  },
  //删除
  deleteWeb(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceAzureAppService/delete`,param);
  },
  //导出Azure应用程序的使用情况
  exportAzureAppServiceUseCondition(params) {
    return $http.post(`${global.API_URL}/sme/resourceAzureAppService/exportAzureAppServiceUseCondition`, params, {
        responseType: 'arraybuffer',
        timeout: 1000 * 60 * 5
    });
  }
}

export default resourceAzureAppService;



// WEBPACK FOOTER //
// ./src/api/resourceAzureAppService.js